import {
  Modal,
  ModalContent,
  ModalContentBody,
  Text,
} from "@zapier/design-system";

import DeleteModalContent from "./DeleteModalContent";

type Props = {
  onClosed: () => void;
};

export function DeleteModal({ onClosed }: Props) {
  const header = "Delete Canvas";

  return (
    <Modal onClosed={onClosed} aria-label={header}>
      <ModalContent>
        <Text type="SectionHeader" margin="0 0 23px 0">
          {header}
        </Text>
        <ModalContentBody>
          <DeleteModalContent onClosed={onClosed} />
        </ModalContentBody>
      </ModalContent>
    </Modal>
  );
}
